import { useState, useEffect } from 'react';
import { File, FolderPlus, Download, Edit, Trash, ChevronRight, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface FileNode {
  name: string;
  path: string;
  type: 'file' | 'directory';
  children?: FileNode[];
}

export const FileManager = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [files, setFiles] = useState<FileNode[]>([]);

  const { data: fileList } = useQuery({
    queryKey: ['files'],
    queryFn: async () => {
      const { data, error } = await supabase.storage
        .from('project-files')
        .list();
      
      if (error) throw error;
      return data;
    },
  });

  const renderFileTree = (node: FileNode) => (
    <div key={node.path} className="flex items-center gap-2 py-1">
      {node.type === 'file' ? (
        <File className="h-4 w-4" />
      ) : (
        <FolderPlus className="h-4 w-4" />
      )}
      <span className="text-sm">{node.name}</span>
    </div>
  );

  return (
    <div className={`panel flex flex-col ${isExpanded ? 'w-64' : 'w-12'}`}>
      <div className="panel-header">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsExpanded(!isExpanded)}
          className="icon-button"
        >
          {isExpanded ? <ChevronRight className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </Button>
        {isExpanded && (
          <div className="flex gap-1">
            <Button variant="ghost" size="icon" className="icon-button">
              <FolderPlus className="h-4 w-4" />
            </Button>
            <Button variant="ghost" size="icon" className="icon-button">
              <Download className="h-4 w-4" />
            </Button>
            <Button variant="ghost" size="icon" className="icon-button">
              <Edit className="h-4 w-4" />
            </Button>
            <Button variant="ghost" size="icon" className="icon-button">
              <Trash className="h-4 w-4" />
            </Button>
          </div>
        )}
      </div>
      {isExpanded && (
        <div className="flex-1 overflow-y-auto p-2">
          {files.map(renderFileTree)}
        </div>
      )}
    </div>
  );
};